import { render, staticRenderFns } from "./Catalogs.vue?vue&type=template&id=4fd67a95&scoped=true"
import script from "./Catalogs.vue?vue&type=script&lang=js"
export * from "./Catalogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd67a95",
  null
  
)

export default component.exports